import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    GET_POS_RATIO,
    GET_POS_RATIO_SUCCESS,
    GET_POS_RATIO_ERROR,
}
    from "../../actions/payment"

function* getPosRatioSaga(action) {
    try {
       const data  = yield call(paymentService.GetPosRatio,action.payload)
       yield put({
        type: GET_POS_RATIO_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: GET_POS_RATIO_ERROR,error: error.data
        })
    }
}


export function* getPosRatioSagaWatcher() {
    yield takeLatest(GET_POS_RATIO, getPosRatioSaga)
}